import React from 'react'
import PropTypes from 'prop-types'

const FlightOffersHeader = ({ heading, description }) => (
  <header>
    <h1>{heading}</h1>
    <p className="-lead">{description}</p>
  </header>
)

FlightOffersHeader.propTypes = {
  heading: PropTypes.string,
  description: PropTypes.string,
}
export default FlightOffersHeader
